import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-text">HotSide</span>
              <span className="logo-accent">Repairs</span>
            </Link>
            <p className="footer-description">
              Connecting businesses with trusted commercial cooking equipment repair
              services across the United States. Available 24/7 for your emergency repairs.
            </p>
            <div className="social-links">
              <a href="https://twitter.com/hotsiderepairs" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
                </svg>
              </a>
              <a href="https://facebook.com/hotsiderepairs" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a href="https://linkedin.com/company/hotsiderepairs" target="_blank" rel="noopener noreferrer" className="social-link">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-links-grid">
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/list-your-business">List Your Business</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/blog">Blog</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Popular Cities</h3>
              <ul>
                <li><Link to="/new-york">New York</Link></li>
                <li><Link to="/los-angeles">Los Angeles</Link></li>
                <li><Link to="/chicago">Chicago</Link></li>
                <li><Link to="/houston">Houston</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Support</h3>
              <ul>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3>Contact</h3>
              <ul className="contact-info">
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  <span>(800) 123-4567</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <span>support@hotsiderepairs.com</span>
                </li>
                <li>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                  </svg>
                  <span>New York, NY 10001</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} HotSide Repairs. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/sitemap">Sitemap</Link>
            <Link to="/accessibility">Accessibility</Link>
            <Link to="/cookies">Cookie Policy</Link>
          </div>
        </div>
      </div>

      <style>
        {`
          .footer {
            background: linear-gradient(145deg, #1a1a1a, #000);
            color: #ffffff;
            padding: 6rem 0 2rem;
            margin-top: 6rem;
            border-top: 4px solid #ff6b35;
            position: relative;
          }

          .footer-content {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 1rem;
          }

          .footer-main {
            display: grid;
            grid-template-columns: 1.5fr 2fr;
            gap: 4rem;
            margin-bottom: 3rem;
          }

          .footer-brand {
            max-width: 400px;
          }

          .footer-logo {
            display: inline-block;
            text-decoration: none;
            font-size: 2rem;
            font-weight: 800;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: #fff;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
          }

          .logo-text {
            color: white;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .logo-accent {
            color: #ff6b35;
            text-transform: uppercase;
            letter-spacing: 1px;
          }

          .footer-description {
            color: #fff;
            line-height: 1.8;
            margin-bottom: 2rem;
            font-size: 1.1rem;
            font-weight: 300;
            opacity: 0.9;
          }

          .social-links {
            display: flex;
            gap: 1rem;
          }

          .social-link {
            color: #bbb;
            transition: color var(--transition-normal);
          }

          .social-link:hover {
            color: #ff6b35;
            transform: translateY(-2px);
          }

          .footer-links-grid {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 2rem;
          }

          .footer-section h3 {
            color: #ff6b35;
            font-size: 1.25rem;
            margin-bottom: 1.5rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 1px;
            position: relative;
            padding-left: 15px;
            text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
          }

          .footer-section ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .footer-section ul li {
            margin-bottom: 0.75rem;
          }

          .footer-section ul li a {
            color: rgba(255,255,255,0.9);
            text-decoration: none;
            transition: all 0.3s ease;
            display: inline-block;
            padding: 6px 0;
            font-size: 1.1rem;
            font-weight: 300;
          }

          .footer-section ul li a:hover {
            color: #ff6b35;
            transform: translateX(5px);
          }

          .footer-section ul li a:hover {
            color: #ff6b35;
            transform: translateX(5px);
          }

          .contact-info li {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            color: #bbb;
          }

          .contact-info svg {
            flex-shrink: 0;
          }

          .footer-bottom {
            border-top: 1px solid rgba(255,255,255,0.1);
            padding-top: 2rem;
            margin-top: 4rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: rgba(255,255,255,0.7);
            font-size: 1rem;
            font-weight: 300;
          }

          .footer-bottom-links {
            display: flex;
            gap: 1.5rem;
          }

          .footer-bottom-links a {
            color: #999;
            text-decoration: none;
            transition: color var(--transition-normal);
          }

          .footer-bottom-links a:hover {
            color: var(--primary-color);
          }

          @media (max-width: 1024px) {
            .footer-main {
              grid-template-columns: 1fr;
              gap: 2rem;
            }

            .footer-brand {
              max-width: 100%;
              text-align: center;
            }

            .social-links {
              justify-content: center;
            }

            .footer-links-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (max-width: 640px) {
            .footer {
            background: linear-gradient(145deg, #1a1a1a, #000);
            color: #ffffff;
            padding: 6rem 0 2rem;
            margin-top: 6rem;
            border-top: 4px solid #ff6b35;
            position: relative;
          }

            .footer-links-grid {
              grid-template-columns: 1fr;
              text-align: center;

          .footer-section h3::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 8px;
            height: 8px;
            background: #ff6b35;
            border: 1px solid #ff8b35;
            border-radius: 2px;
          }

          .footer-section {
            position: relative;
          }

          .footer-section::after {
            content: '';
            position: absolute;
            top: 0;
            right: -1rem;
            width: 2px;
            height: 100%;
            background: linear-gradient(180deg, transparent, #333, transparent);
          }

          .footer-section:last-child::after {
            display: none;
          }

          .contact-info li {
            position: relative;
            padding-left: 30px;
          }

          .contact-info svg {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            color: #ff6b35;
          }

          .footer-bottom {
            border-top: 1px solid rgba(255,255,255,0.1);
            padding-top: 2rem;
            margin-top: 4rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: rgba(255,255,255,0.7);
            font-size: 1rem;
            font-weight: 300;
          }

          .footer-bottom::before {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 80%;
            height: 1px;
            background: linear-gradient(90deg, transparent, #333, transparent);
          }

            }

            .contact-info li {
              justify-content: center;
            }

            .footer-bottom {
            border-top: 1px solid rgba(255,255,255,0.1);
            padding-top: 2rem;
            margin-top: 4rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: rgba(255,255,255,0.7);
            font-size: 1rem;
            font-weight: 300;
          }

            .footer-bottom-links {
              flex-direction: column;
              gap: 0.5rem;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;